import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ClinicalAlertsAPI } from "../infrastructure/api/ClinicalAlerts.api";
import { ClinicalAlertCreate, ClinicalAlertUpdate } from "../domain/ClinicalAlert";

export const useClinicalAlerts = () => {
    return useQuery({
        queryKey: ["clinical-alerts"],
        queryFn: async () => {
            const { data } = await ClinicalAlertsAPI.list();
            return data;
        },
    });
};

export const useCreateClinicalAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data: ClinicalAlertCreate) => ClinicalAlertsAPI.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["clinical-alerts"] });
        },
    });
};

export const useUpdateClinicalAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: ClinicalAlertUpdate }) => ClinicalAlertsAPI.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["clinical-alerts"] });
        },
    });
};

export const useDeleteClinicalAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => ClinicalAlertsAPI.delete(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["clinical-alerts"] });
        },
    });
};
